import makeStyles from '@mui/styles/makeStyles';

export const getObsStyles = (theme) => ({
    root: {
        width: '100%',
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
    },
    modalContentView: {
        background: theme.palette.background.defaultBackground,
    },
    observationsColumn: {
        position: 'relative',
        scrollBehavior: 'smooth',
    },
    paperDarker: {
        background: theme.palette.background.paperDarker,
    },
    observationsContent: {
        background: theme.palette.background.defaultBackground,
        width: '100%',
        margin: 0,
        padding: 10,

        '& .MuiChip-outlined': {
            background: theme.palette.background.paper,
        },
        '& .MuiChip-default': {
            color: theme.palette.background.paperSelectedText,
            background: theme.palette.background.paperSelected,
        },
    },
    observationsContentIpod: {
        padding: 0,
        paddingBottom: 10,
    },
    obsRoot: {
        '& .MuiChip-default': {
            background: theme.palette.mode === 'light' ? '' : '#777',
        },
    },
    obsScroll: {
        height: 'calc(95vh - 70px - 150px)',
        paddingRight: 12,
        scrollBehavior: 'smooth',
    },
    obsScrollIpod: {},
    obsFooter: {
        height: 45,
    },
    obsContent: {
        borderRadius: '5px',
        padding: 10,
    },
    obsLabel: {
        padding: '0 5px 5px',
        fontWeight: 'bold',
        fontSize: '18px',
        borderBottom: '1px solid ' + theme.palette.divider,
    },
    numericStepper: {
        borderRadius: '6px',
        backgroundColor: theme.palette.mainScreenButton.formFilledDetails,
        color: theme.palette.primary.mainColor,
        padding: '10px 5px',
        '&.float': {
            padding: '0 5px',
            float: 'right',
        },
        '&.noBackground': {
            backgroundColor: 'unset',
        },
        '&.medicationInput': {
            padding: '0px',
            borderColor: 'transparent',
            border: '1px solid',
        },
        '&.error': {
            boxSizing: 'border-box',
            borderColor: theme.palette.error.main,
            border: '1px solid',
        },
    },
    numericStepperMain: {
        width: '100%',
    },
    numericStepperLabel: {
        flexGrow: 1,
        paddingLeft: 5,
        color: theme.palette.mode === 'light' ? '#494B4C' : '#ACAFB3',
        fontSize: 13,
        '&.margin': {
            marginBottom: 5,
        },
    },
    numericStepperTextField: {
        width: '120px',
        // hide native numeric stepper
        '& input[type=number]': {
            '-moz-appearance': 'textfield',
            padding: 0,
            color: theme.palette.primary.mainColor,
        },
        '& input[type=number]::-webkit-outer-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0,
        },
        '& input[type=number]::-webkit-inner-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0,
        },
        '& input:focus': {
            outline: 'none',
        },
        '& input': {
            textAlign: 'center',
        },
    },
    numericStepperInput: {
        textAlign: 'center',
        // color: theme.palette.background.paper,
        color: theme.palette.primary.mainColor,
    },
    numericStepperIcon: {
        color: theme.palette.mode === 'light' ? theme.palette.primary.main : '#ffffff',
        marginLeft: 5,
        marginRight: 5,
        borderRadius: 6,
        height: 40,
        width: 40,
        border: `1px solid ${theme.palette.mode === 'light' ? theme.palette.primary.main : '#494b4c'}`,
        backgroundColor: theme.palette.mode === 'light' ? '#ffffff' : '#494b4c',
    },
    obsButton: {
        maxWidth: '150px',
        width: '100px',
    },
    obsSaveButton: {
        width: '300px',
    },
    obsButtonIpod: {
        maxWidth: '90px',
    },
    ipodSaveButtonGroup: {
        float: 'left',
    },
    snackObs: {
        bottom: 100,
    },
    scoreRoot: {
        color: theme.palette.success.contrastText,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderRadius: 6,
        padding: '1px 8px',
        minWidth: 100,
        fontSize: 14,
        lineHeight: '24px',
        fontWeight: 'bold',
        '&.score0': {
            backgroundColor: theme.palette.observation.white,
            color: theme.palette.observation.text,
            fontWeight: 'bold',
            border: `1px solid ${theme.palette.observation.border}`,
        },
        '&.score1': {
            backgroundColor: theme.palette.observation.yellow,
            color: theme.palette.observation.text,
            fontWeight: 'bold',
        },
        '&.score2': {
            backgroundColor: theme.palette.observation.amber,
            color: theme.palette.observation.text,
            fontWeight: 'bold',
        },
        '&.score3': {
            backgroundColor: theme.palette.observation.red,
            color: theme.palette.observation.text,
            fontWeight: 'bold',
        },
        '&.score4': {
            backgroundColor: theme.palette.observation.pink,
            color: theme.palette.observation.text,
            fontWeight: 'bold',
        },
        '&.neuroLow': {
            backgroundColor: theme.palette.success.light,
            color: theme.palette.success.contrastText,
            fontWeight: 'bold',
        },
        '&.neuroMedium': {
            backgroundColor: theme.palette.warning.light,
            color: theme.palette.warning.contrastText,
            fontWeight: 'bold',
        },
        '&.neuroHigh': {
            backgroundColor: theme.palette.error.light,
            color: theme.palette.error.contrastText,
            fontWeight: 'bold',
        },
        '&.neuro': {
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.primary.contrastText,
            fontWeight: 'bold',
        },
    },
    acceptButton: {
        minWidth: 160,
        marginLeft: 15,
    },
    component: {
        backgroundColor: theme.palette.mode === 'light' ? '#f6f6f6' : '#222425',
        borderRadius: 6,
        padding: '10px 15px',
        marginTop: 16,
        marginLeft: 7,
    },
    dictField: {
        border: '1px solid red',
    },
    scoreLabel: {
        display: 'inline-block',
        borderRadius: 10,
    },
    obsStatus: {
        backgroundColor: '#999 !important',
    },
    scoreBadge: {
        display: 'inline-block',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '5px 10px',
        borderRadius: 8,
        maxWidth: 120,
        minWidth: 35,
        backgroundColor: theme.palette.success.light,
        color: theme.palette.success.paperSelectedText,
        fontWeight: 'bold',
        '&.score0': {
            backgroundColor: theme.palette.observation.white,
            color: theme.palette.observation.text,
            fontWeight: 'bold',
        },
        '&.score1': {
            backgroundColor: theme.palette.observation.yellow,
            color: theme.palette.observation.text,
            fontWeight: 'bold',
        },
        '&.score2': {
            backgroundColor: theme.palette.observation.amber,
            color: theme.palette.observation.text,
            fontWeight: 'bold',
        },
        '&.score3': {
            backgroundColor: theme.palette.observation.red,
            color: theme.palette.observation.text,
            fontWeight: 'bold',
        },
        '&.score4': {
            backgroundColor: theme.palette.observation.pink,
            color: theme.palette.observation.text,
            fontWeight: 'bold',
        },
        '&.neuroLow': {
            backgroundColor: theme.palette.success.light,
            color: theme.palette.success.contrastText,
            fontWeight: 'bold',
        },
        '&.neuroMedium': {
            backgroundColor: theme.palette.warning.light,
            color: theme.palette.warning.contrastText,
            fontWeight: 'bold',
        },
        '&.neuroHigh': {
            backgroundColor: theme.palette.error.light,
            color: theme.palette.error.contrastText,
            fontWeight: 'bold',
        },
        '&.neuro': {
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.primary.contrastText,
            fontWeight: 'bold',
        },
        textAlign: 'center',
    },
    acceptDate: {
        textAlign: 'right',
        fontSize: 12,
    },
    airTypeChip: {
        width: '100%',
    },
    deviceLabel: {
        paddingTop: 10,
        fontSize: '1.25rem',
        borderTop: '1px solid ' + theme.palette.divider,
    },
    label: {
        color: theme.palette.mode === 'light' ? '#626466' : '#ACAFB3',
        fontWeight: 'bold',
    },
    statusChips: {
        textAlign: 'center',
        paddingTop: '8px !important',
    },
    statusChip: {
        margin: 2,
    },
    deviceChips: {
        textAlign: 'center',
        paddingTop: '8px !important',
    },
    deviceChip: {
        margin: 2,
    },
    spo2Chip: {
        width: '100%',
    },
    disabled: {
        cursor: 'not-allowed',
    },
    armChip: {
        width: '100%',
    },
    pulseChip: {
        width: '100%',
    },
    consciousnessLevelChips: {
        textAlign: 'center',
        paddingTop: '8px !important',
        paddingBottom: 10,
    },
    consciousnessLevelChip: {
        margin: 2,
    },
    distressChips: {
        textAlign: 'center',
        paddingTop: '8px !important',
        marginTop: 10,
    },
    distressChip: {
        margin: 2,
    },
    wheezingLevelChips: {
        textAlign: 'center',
        paddingTop: '8px !important',
        marginTop: 10,
    },
    wheezingLevelChip: {
        margin: 2,
    },
    stridorChip: {
        width: '100%',
    },
    apnoeaChip: {
        width: '100%',
    },
    tempPlaceChips: {
        textAlign: 'center',
        paddingTop: '8px !important',
        marginTop: 10,
    },
    tempPlaceChip: {
        margin: 2,
    },
    eyesClosedChip: {
        width: '100%',
    },
    eyesOpenLevelChips: {
        textAlign: 'center',
        paddingTop: '8px !important',
        marginTop: 10,
    },
    eyesOpenLevelChip: {
        margin: 2,
    },
    tracheostomyChip: {
        width: '100%',
    },
    bestVerbalResponseChips: {
        textAlign: 'center',
        paddingTop: '8px !important',
        marginTop: 10,
    },
    bestVerbalResponseChip: {
        margin: 2,
    },
    bestMotorResponseChips: {
        textAlign: 'center',
        paddingTop: '8px !important',
        marginTop: 10,
    },
    bestMotorResponseChip: {
        margin: 2,
    },
    pupilScaleChips: {
        textAlign: 'center',
        paddingTop: '8px !important',
    },
    pupilScaleChip: {
        margin: 2,
    },
    movementChips: {
        textAlign: 'center',
        paddingTop: '8px !important',
        marginTop: 10,
    },
    movementChip: {
        margin: 2,
    },
    movementSeparator: {
        paddingTop: 10,
        borderTop: '1px solid ' + theme.palette.divider,
    },
    pupilLabel: {
        paddingTop: 10,
        fontSize: '1.25rem',
    },
    pupilLabelBorder: {
        borderTop: '1px solid ' + theme.palette.divider,
    },
    consciousnessWarning: {
        color: theme.palette.warning.light,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    oxygenDeviceWarning: {
        color: theme.palette.warning.light,
        fontWeight: 'bold',
        textAlign: 'center',
        fontSize: 'small',
    },
    painScale: {
        display: 'inline-flex',
        width: '100%',
        background: theme.palette.mode === 'light' ? '#666666' : '',
    },
    pupilScale: {
        display: 'inline-flex',
        width: '100%',
        height: '140px',
    },
    painScaleImage: {
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '90%',
    },
    sectionColumn: {
        paddingRight: 10,
        marginTop: 11,
    },
    sectionItem: {
        margin: '4px 0 0 5px',
        borderRadius: '5px',
        display: 'inline-flex',
        width: 'calc(100% - 5px)',
        minHeight: '45px',
        cursor: 'pointer',
        '&:hover': {
            opacity: 0.7,
        },
        padding: '5px 10px',
        fontWeight: 'normal',
        lineHeight: '24px',
        fontSize: '14px',
        backgroundColor: theme.palette.background.defaultBackground,
        borderTopRightRadius: 10,
        borderBottomRightRadius: 10,
        position: 'relative',
        zIndex: 4,
    },
    sectionItemSelected: {
        backgroundColor: theme.palette.background.defaultBackground,
    },
    patientBar: {
        backgroundColor: theme.palette.background.paperDarker,
        marginBottom: 5,
    },
    sectionLabel: {
        flexGrow: 1,
        userSelect: 'none',
        paddingTop: 3,
        fontWeight: 500,
    },
    sectionItemAcceptedIndicatorLeft: {
        position: 'absolute',
        right: 0,
        width: '15px',
        height: '30px',
        display: 'inline-block',
        backgroundColor: theme.palette.default.main,
        zIndex: 255,
        borderTopRightRadius: 10,
        borderBottomRightRadius: 10,
    },
    sectionItemAcceptedIndicatorRight: {
        position: 'absolute',
        right: 5,
        width: '10px',
        height: '30px',
        display: 'inline-block',
        backgroundColor: theme.palette.background.default,
        zIndex: 355,
        borderTopRightRadius: 12,
        borderBottomRightRadius: 12,
    },
    sectionScore: {
        fontWeight: 'bold',
        '&.score0': {
            backgroundColor: theme.palette.observation.white,
            color: theme.palette.observation.text,
            fontWeight: 'bold',
            border: `1px solid ${theme.palette.observation.border}`,
        },
        '&.score1': {
            backgroundColor: theme.palette.observation.yellow,
            color: theme.palette.observation.text,
            fontWeight: 'bold',
        },
        '&.score2': {
            backgroundColor: theme.palette.observation.amber,
            color: theme.palette.observation.text,
            fontWeight: 'bold',
        },
        '&.score3': {
            backgroundColor: theme.palette.observation.red,
            color: theme.palette.observation.text,
            fontWeight: 'bold',
        },
        '&.score4': {
            backgroundColor: theme.palette.observation.pink,
            color: theme.palette.observation.text,
            fontWeight: 'bold',
        },
        '&.neuroLow': {
            backgroundColor: theme.palette.success.light,
            color: theme.palette.success.contrastText,
            fontWeight: 'bold',
        },
        '&.neuroMedium': {
            backgroundColor: theme.palette.warning.light,
            color: theme.palette.warning.contrastText,
            fontWeight: 'bold',
        },
        '&.neuroHigh': {
            backgroundColor: theme.palette.error.light,
            color: theme.palette.error.contrastText,
            fontWeight: 'bold',
        },
        '&.neuro': {
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.primary.contrastText,
            fontWeight: 'bold',
        },
        borderRadius: '5px',
        width: 30,
        height: 30,
        textAlign: 'center',
        paddingTop: 3,
        marginRight: 10,
    },
    sectionScoreSelected: {
        maxWidth: 130,
    },
    totalScoreRootBorder: {
        borderTop: '1px solid ' + theme.palette.divider,
        marginTop: 10,
        paddingTop: 5,
    },
    totalScoreRootInner: {
        display: 'inline-block',
    },
    totalScoreLabel: {
        fontSize: '18px',
        display: 'inline-block',
    },
    totalScoreValue: {
        fontWeight: 'bold',
        fontSize: '28px',
        display: 'flex',
    },
    totalScoreEscalation: {
        display: 'flex',
        alignItems: 'center',
    },
    totalScoreEscalationArrow: {
        display: 'inline-block',
        verticalAlign: 'middle',
    },
    totalScoreEscalationArrowIcon: {
        display: 'flex',
        justifyContent: 'center',
    },
    nextObsCombo: {
        width: '225px',
        '& input': {
            fontSize: '14px',
        },
    },
    nextObsContent: {
        fontSize: '14px',
        margin: '5px 0',
        marginTop: 10,
    },
    nextObsValue: {
        marginLeft: theme.spacing(6),
    },
    clinicalResponseItem: {
        margin: '10px 0',
    },
    clinicalResponseHeader: {
        border: '1px solid ' + theme.palette.background.paper,
        borderTopLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius,
        background: theme.palette.background.paper,
        fontSize: '16px',
        fontWeight: 'bold',
        padding: theme.spacing(1),
        '&.medium': {
            border: '1px solid ' + theme.palette.observation.yellow,
        },
    },
    clinicalResponseContent: {
        fontSize: '14px',
        padding: theme.spacing(1),
        whiteSpace: 'break-spaces',
    },
    listButton: {
        cursor: 'pointer',
    },
    mainContent: {
        background: theme.palette.background.paper,
        borderRadius: theme.spacing(1),
        margin: theme.spacing(1),
        padding: theme.spacing(1),
    },
    obsResultsContent: {
        background: theme.palette.mode === 'light' ? '#fff' : '#222425',
        borderRadius: theme.spacing(1),
        margin: 0, //theme.spacing(1),
        paddingRight: theme.spacing(1),
        height: `calc(100% - 73px)`,
        marginLeft: 4,
        overflowX: 'hidden',
    },
    addNewObservation: {
        backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#313233',
        border: `1px solid ${theme.palette.mode === 'light' ? '#ACAFB3' : '#494B4C'}`,
        borderRadius: 6,
        padding: '12px 12px 12px 10px',
        marginTop: 6,
        position: 'fixed',
        right: 22,
        left: 165,
        height: `calc(100% - 176px)`,
        pointerEvents: 'none',
    },
    obsGridItem: {
        overflowX: 'auto',
    },
    obsLabelTable: {
        width: '160px',
        maxWidth: '160px',
        minWidth: '160px',
        borderSpacing: '6px',
        fontWeight: 'bold',
        fontSize: 'small',
    },
    obsLabelCellHeader: {
        height: '62px',
        width: '100%',
        borderSpacing: 0,
        background: theme.palette.background.paper,
        borderRadius: theme.shape.borderRadius,
        padding: 6,
    },
    obsLabelCell: {
        height: '34px',
        maxWidth: '148px',
        width: '100%',
        padding: 6,
        background: theme.palette.background.paper,
        borderRadius: theme.shape.borderRadius,
    },
    obsLabelCellChartMode: {
        cursor: 'pointer',
    },
    obsValueTable: {
        borderSpacing: '0 6px',
    },
    tableStyle: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        width: '100%',
        marginTop: '-5px',
    },
    obsValueCell: {
        height: '34px',
        width: '150px',
        maxWidth: '140px',
        minWidth: '140px',
        background: theme.palette.background.paperDarker,
        borderRadius: theme.shape.borderRadius,
        textAlign: 'center',
        fontSize: 12,
        borderBottom: theme.palette.mode === 'light' ? '1px groove' : 'none',
        '&.noBorderRadius': {
            borderRadius: 0,
        },
        '&.noBorderRadiusLeft': {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
        },
        '&.noBorderRadiusRight': {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
        },
    },
    completedDate: {
        fontSize: 13,
        display: 'flex',
        paddingLeft: 10,
        marginTop: -5,
    },
    obsValueCellActions: {
        height: '60px',
        width: '140px',
        maxWidth: '140px',
        minWidth: '140px',
        background: theme.palette.background.paper,
        borderRadius: theme.shape.borderRadius,
        textAlign: 'center',
    },
    obsValueCanceledCell: {
        textDecoration: 'line-through',
        opacity: 0.7,
    },
    obsColorLow: {
        backgroundColor: theme.palette.observation.white,
        color: theme.palette.observation.text,
        border: `1px solid ${theme.palette.observation.border}`,
    },
    obsColorMediumLow: {
        backgroundColor: theme.palette.observation.yellow,
        color: theme.palette.observation.text,
    },
    obsColorMedium: {
        backgroundColor: theme.palette.observation.amber,
        color: theme.palette.observation.text,
    },
    obsColorHigh: {
        backgroundColor: theme.palette.observation.red,
        color: theme.palette.observation.text,
    },
    obsColorUnknown: {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.primary.contrastText,
    },
    obsColorRiskContinue: {
        backgroundColor: '#c2d69b',
        color: '#000000',
        '&:hover': {
            backgroundColor: '#c2d69b',
            color: '#000000',
        },
    },
    obsColorAmber: {
        backgroundColor: '#FFC790',
        color: '#000000',
        '&:hover': {
            backgroundColor: '#FFC790',
            color: '#000000',
        },
    },
    obsColorRed: {
        backgroundColor: '#F79781',
        color: '#000000',
        '&:hover': {
            backgroundColor: '#F79781',
            color: '#000000',
        },
    },
    obsColorYellow: {
        backgroundColor: '#FFF6B2',
        color: '#000000',
        '&:hover': {
            backgroundColor: '#FFF6B2',
            color: '#000000',
        },
    },
    obsColorPink: {
        backgroundColor: '#FECDDC',
        color: '#000000',
        '&:hover': {
            backgroundColor: '#FECDDC',
            color: '#000000',
        },
    },
    obsColorWhite: {
        backgroundColor: '#FFFFFF',
        color: '#000000',
        '&:hover': {
            backgroundColor: '#FFFFFF',
            color: '#000000',
        },
    },
    obsColorRiskLow: {
        backgroundColor: '#ffff99',
        color: '#000000',
        '&:hover': {
            backgroundColor: '#ffff99',
            color: '#000000',
        },
    },
    obsColorRiskMedium: {
        backgroundColor: '#fabf8f',
        color: '#000000',
        '&:hover': {
            backgroundColor: '#fabf8f',
            color: '#000000',
        },
    },
    obsColorRiskHigh: {
        backgroundColor: '#e5b8b7',
        color: '#000000',
        '&:hover': {
            backgroundColor: '#e5b8b7',
            color: '#000000',
        },
    },
    obsColorRiskEmergency: {
        backgroundColor: '#c0504d',
        color: '#fff',
        '&:hover': {
            backgroundColor: '#c0504d',
            color: '#fff',
        },
    },
    emptyChartInfo: {
        fontWeight: 'bold',

        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
    },
    optionRoot: {
        width: '100%',
    },
    optionLabel: {
        flexGrow: 1,
        fontWeight: 'bolder',
    },
    optionLabelShort: {
        maxWidth: '420px',
    },
    optionLabelWarning: {
        color: theme.palette.warning.light,
    },
    optionCheckLeft: {
        marginLeft: '0px',
    },
    optionCheckRight: {
        float: 'right',
        marginRight: '0px',
    },
    venturiContainer: {
        maxWidth: '100%',
        padding: '10px 30px 10px 30px',
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    divRow: {
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 8,
        '&.np-flex': {
            alignItems: 'normal',
        },
        '&.psButtons': {
            padding: 10,
            justifyContent: 'center',
        },
        '&.mobile': {
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: 10,
        },
        '&.medicationInput': {
            marginBottom: 0,
        },
    },
    divider: {
        margin: '10px 0',
    },
    dividerVertical: {
        margin: '1px 10px',
        borderWidth: '1px',
    },
    toRight: {
        marginLeft: 'auto',
        gap: 20,
    },
    actionButtons: {
        backgroundColor: 'transparent',
        color: theme.palette.mode === 'light' ? theme.palette.primary.main : '#fff',
        border: `1px solid ${theme.palette.mode === 'light' ? theme.palette.primary.main : '#fff'}`,
        borderRadius: 5,
        '&.selected': {
            backgroundColor: theme.palette.mode === 'light' ? theme.palette.primary.main : '#fff',
            color: theme.palette.mode === 'light' ? '#fff' : '#222425',
        },
        '&.filled': {
            backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#494b4c',
            borderColor: theme.palette.mode === 'light' ? theme.palette.primary.main : '#494b4c',
            color: theme.palette.mode === 'light' ? theme.palette.primary.main : '#fff',
            '&.Mui-disabled': {
                borderColor: theme.palette.mode === 'light' ? '#d6d7d9' : '#494b4c',
                color: theme.palette.mode === 'light' ? '#d6d7d9' : '#909192',
            },
        },
        '&.Mui-disabled': {
            borderColor: theme.palette.mode === 'light' ? '#eaeaea' : '#676767',
        },
    },
    actionButtonRow: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        gap: 10,
    },
    nextObsStatus: {
        width: '100%',
        color: theme.palette.mode === 'light' ? '#494b4c' : '#FFF',
        backgroundColor: theme.palette.mode === 'light' ? '#EFF1F3' : '#3d3e40',
        border: `1px solid ${theme.palette.mode === 'light' ? '#BFC2C7' : '#626466'}`,
        borderRadius: 6,
        padding: 5,
        display: 'flex',
        flexDirection: 'row',
        height: 35,
    },
    actionBar: {
        marginTop: 16,
        marginRight: 16,
        gap: 20,
        display: 'flex',
        margin: '0 10px',
        marginBottom: 8,
    },
    nextObsIcon: {
        borderRight: `1px solid ${theme.palette.mode === 'light' ? '#BFC2C7' : '#626466'}`,
        paddingRight: 10,
        paddingLeft: 5,
        lineHeight: 1,
    },
    nextObsText: {
        paddingLeft: 10,
        fontSize: 13,
    },
    singleIconContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 10,
        textAlign: 'center',
    },
    addNewButton: {
        color: theme.palette.primary.main,
        position: 'sticky',
        top: 13,
    },
    addNewButtonUp: {
        width: '100%',
        padding: 5,
    },
});

export const obsStyles = makeStyles((theme) => ({
    ...getObsStyles(theme),
}));

export const obsStylesMews = makeStyles((theme) => ({
    ...getObsStyles(theme),
    scoreRoot: {
        ...getObsStyles(theme).scoreRoot,
        '&.score2': {
            backgroundColor: theme.palette.observation.pink,
            color: theme.palette.observation.text,
            fontWeight: 'bold',
        },
    },
    scoreBadge: {
        ...getObsStyles(theme).scoreBadge,
        '&.score2': {
            backgroundColor: theme.palette.observation.pink,
            color: theme.palette.observation.text,
            fontWeight: 'bold',
        },
    },
    sectionScore: {
        ...getObsStyles(theme).sectionScore,
        '&.score2': {
            backgroundColor: theme.palette.observation.pink,
            color: theme.palette.observation.text,
            fontWeight: 'bold',
        },
        '&.score3': {
            backgroundColor: theme.palette.observation.pink,
            color: theme.palette.observation.text,
            fontWeight: 'bold',
        },
        '&.score4': {
            backgroundColor: theme.palette.observation.pink,
            color: theme.palette.observation.text,
            fontWeight: 'bold',
        },
    },
}));
